// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	firebase: {
		apiKey: 'AIzaSyA5D9EE-3DtZez0oBA3rHNBvNv-iBYC30s',
		authDomain: 'fasttrack-250918.firebaseapp.com',
		databaseURL: 'https://fasttrack-250918.firebaseio.com',
		projectId: 'fasttrack-250918',
		storageBucket: '',
		messagingSenderId: '769274712507',
		appId: '1:769274712507:web:8a701eb15eff00913fb49e',
	},
	socialLoginsProvidersClientIds: {
		googleLoginProvider: '769274712507-l2el8crtv5q23440gi0hjg9d0q32e54j.apps.googleusercontent.com',
		facebookLoginProvider: '3247112295313282'
	},
	appInsights: {
		instrumentationKey: '9f63a1b6-7ee8-4a38-b296-04902adbd892',
	},
	googleAnalyticsTrackingCode: '',
	api: {
		baseUrl: 'https://tapi.itsfb.com',
		fasttrackApi: 'https://tapi.itsfb.com/api',
	},
	imagesCompression: {
		articles: {
			width: 1920,
			height: 1080,
			quality: 80
		},
		articlesImages: {
			width: 1280,
			height: 720,
			quality: 60
		},
		blog: {
			width: 1366,
			height: 768,
			quality: 85
		},
		gallery: {
			width: 1366,
			height: 768,
			quality: 85
		},
		chat: {
			width: 800,
			height: 600,
			quality: 83
		}
	}
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
